"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const mx = __importStar(require("../../mixins"));
const AnimateFade_1 = require("../AnimateFade");
// Convenience functions to support the dynamic value changes
// and transitions of the single css property `transform`.
const getTranslate = (x, y) => [].concat(getTranslateX(x), getTranslateY(y)).join(" ");
const getTranslateX = amount => amount != null ? `translateX(${amount})` : [];
const getTranslateY = amount => amount != null ? `translateY(${amount})` : [];
exports.Wrapper = (0, styled_components_1.default)(AnimateFade_1.Styles.Wrapper)`
  ${_ref => {
  let {
    duration
  } = _ref;
  return mx.accessibleTransition("transform, opacity", duration);
}};
  position: relative;

  ${_ref2 => {
  let {
    toggle,
    animX,
    animY
  } = _ref2;
  return (0, styled_components_1.css)`
    transform: ${getTranslate(animX === null || animX === void 0 ? void 0 : animX.in, animY === null || animY === void 0 ? void 0 : animY.in)};

    ${toggle && (0, styled_components_1.css)`
      transform: ${getTranslate(animX === null || animX === void 0 ? void 0 : animX.out, animY === null || animY === void 0 ? void 0 : animY.out)};
    `};
  `;
}}
`;